import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl'

import { CurrencyDollarIcon, StarIcon, TrophyIcon } from '@gto/ui/icons/solid'

import { PromoBenefitsCard } from './promo-benefits-card'

export const PromoBenefitsSection = () => {
  const { messages } = useIntl()

  return (
    <section className="flex flex-wrap gap-4">
      {benefitsMap.map((benefit, index) => (
        <article
          // eslint-disable-next-line @eslint-react/no-array-index-key -- fixed benefits list literal, never reorders
          key={index}
          className="flex-[1_0_30%] md:flex-[1_0_48%] sm:flex-[1_0_100%]"
        >
          <PromoBenefitsCard
            {...benefit}
            description={messages[`promo.page.benefits_${index as 0 | 1 | 2}.description`] as []}
          />
        </article>
      ))}
    </section>
  )
}

const benefitsMap = [
  {
    title: <FormattedMessage id="promo.page.benefits_0.title" />,
    prize: 20_000,
    topPrize: (
      <FormattedMessage
        id="promo.page.topPrize.gtoElite"
        values={{
          cash: (
            <FormattedNumber
              currency="USD"
              style="currency"
              value={3_000}
            />
          ),
        }}
      />
    ),
    icon: TrophyIcon,
    link: '/promotion/august-2025/rake-race',
  },
  {
    title: <FormattedMessage id="promo.page.benefits_1.title" />,
    prize: 10_000,
    topPrize: <FormattedMessage id="promo.page.topPrize.gtoPremium" />,
    icon: CurrencyDollarIcon,
    link: '/promotion/august-2025/all-in-flip-outs',
  },
  {
    title: <FormattedMessage id="promo.page.benefits_2.title" />,
    prize: 10_000,
    topPrize: <FormattedMessage id="promo.page.topPrize.gtoEliteSimple" />,
    icon: StarIcon,
    link: '/promotion/august-2025/all-in-flip-outs',
  },
]
